import PropTypes from "prop-types";
import React from "react";
import axios from 'axios';
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';

function ErrorBoundaryView({ children, className, error, t, ...rest }) {
  if (error) {
    // Reiniciar engine seleccionado si no existe
    if (error.indexOf("Could not find engine") != -1) {
      axios.post('/familysession.php', {
        family: ""
      })
      .then(function (response) {
        location.reload();
      })
      .catch(function (error) {
        //
      });
    }
    return (
      <div className={"sui-search-error " + className} {...rest}>
        {error.indexOf("Could not find engine") != -1 ? (
          <span>{<Trans>Empty family, resetting filter...</Trans>}</span>
        ) : (
          //<span>{error}</span>
          <span></span>
        )}
      </div>
    );
  }

  return children;
}

ErrorBoundaryView.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.string.isRequired,
  className: PropTypes.string
};

export default ErrorBoundaryView;